/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type ContourTypeEnum = (typeof ContourTypeEnum)[keyof typeof ContourTypeEnum];

export const ContourTypeEnum = {
  MINUTES: 'MINUTES',
  METERS: 'METERS',
} as const;
